import type {ItemObject} from '@PosterWhiteboard/items/item/item.types';
import {AnimationType} from '@PosterWhiteboard/items/item/item.types';
import {isAnimationApplicableForGIType} from '@PosterWhiteboard/animation/animation.class';

export const getConsistentAnimationType = (items: ItemObject[], getType: (item: ItemObject) => AnimationType): AnimationType => {
  const animatedItems = items.filter((item) => getType(item) !== AnimationType.NONE);
  if (animatedItems.length === 0) {
    return AnimationType.NONE;
  }
  const candidateType = getType(animatedItems[0]);
  if (!animatedItems.every((item) => getType(item) === candidateType)) {
    return AnimationType.NONE;
  }
  const allApplicableHaveIt = items
    .filter((item) => isAnimationApplicableForGIType(item.gitype, candidateType))
    .every((item) => getType(item) === candidateType);
  return allApplicableHaveIt ? candidateType : AnimationType.NONE;
};
